import map from 'ramda/es/map';
import urlJoin from 'url-join';

import { ignoreLeadingSlash } from 'utils/string';

export const buildApplicationPaths = <T>(paths: T, prefix: string): T =>
  // @ts-ignore
  map((path) => ignoreLeadingSlash(urlJoin(prefix, path)), paths);
